import type { PracticeArea, ProspectPracticeArea } from '../enums';
import { getPracticeAreaLabel } from '../util';

export interface LawFirmFreeTrialSettings {
    isFreeTrial: boolean;
    freeTrialPracticeAreas?: readonly ProspectPracticeArea[] | null;
}

/**
 * `isFreeTrial` is the on/off switch. An empty area list means all prospect
 * practice areas; a non-empty list limits the trial to those areas.
 * IDV is never free: it is billed by an external provider.
 * `startsAt` / `endsAt` can be added to this check later without changing call sites.
 */
export function isOnFreeTrial(firm: LawFirmFreeTrialSettings, practiceArea: PracticeArea): boolean {
    if (!firm.isFreeTrial || practiceArea === 'IDV') return false;

    const areas = firm.freeTrialPracticeAreas ?? [];
    if (areas.length === 0) return true;

    return areas.includes(practiceArea);
}

export function getBilledBasePrice(
    firm: LawFirmFreeTrialSettings,
    practiceArea: PracticeArea,
    regularPrice: number,
): number {
    return isOnFreeTrial(firm, practiceArea) ? 0 : regularPrice;
}

export function formatFreeTrialPracticeAreas(firm: LawFirmFreeTrialSettings): string {
    if (!firm.isFreeTrial) return 'No';

    const areas = firm.freeTrialPracticeAreas ?? [];
    if (areas.length === 0) return 'All';

    return areas.map((area) => getPracticeAreaLabel(area)).join(', ');
}
